import API_URLS from "constants/apis.url";

import { getRequest } from "./api";

export const getAlarmsHistory = params => getRequest(`${API_URLS.alarmHistoryURL}`, true, { params: params || {} });
